import Renderer from '@FreeRider/Renderers/Renderer';
import Ragdoll, { RagdollMassesMap } from '@FreeRider/Player/Vehicles/Ragdoll';
import Screen from '@FreeRider/Screen';
import Camera from '@FreeRider/Camera';
import Player from '@FreeRider/Player/Player';

class RagdollRenderer extends Renderer
{
    public render(player: Player, ragdoll: Ragdoll, screen: Screen, camera: Camera)
    {
        const masses = ragdoll.masses;

        const head = masses[RagdollMassesMap.HEAD].position;
        const waist = masses[RagdollMassesMap.WAIST].position;
        const left_elbow = masses[RagdollMassesMap.LEFT_ELBOW].position;
        const right_elbow = masses[RagdollMassesMap.RIGHT_ELBOW].position;
        const left_hand = masses[RagdollMassesMap.LEFT_HAND].position;
        const right_hand = masses[RagdollMassesMap.RIGHT_HAND].position;
        const left_knee = masses[RagdollMassesMap.LEFT_KNEE].position;
        const right_knee = masses[RagdollMassesMap.RIGHT_KNEE].position;
        const left_foot = masses[RagdollMassesMap.LEFT_FOOT].position;
        const right_foot = masses[RagdollMassesMap.RIGHT_FOOT].position;

        const zoom = camera.zoom;
        const dir = ragdoll.dir;

        const screenCenterX = screen.width / 2;
        const screenCenterY = screen.height / 2;

        let head_s_x = (head.x - camera.x) * camera.zoom + screenCenterX;
        let head_s_y = (head.y - camera.y) * camera.zoom + screenCenterY;

        const left_elbow_s_x = (left_elbow.x - camera.x) * camera.zoom + screenCenterX;
        const left_elbow_s_y = (left_elbow.y - camera.y) * camera.zoom + screenCenterY;

        const left_hand_s_x = (left_hand.x - camera.x) * camera.zoom + screenCenterX;
        const left_hand_s_y = (left_hand.y - camera.y) * camera.zoom + screenCenterY;

        const right_elbow_s_x = (right_elbow.x - camera.x) * camera.zoom + screenCenterX;
        const right_elbow_s_y = (right_elbow.y - camera.y) * camera.zoom + screenCenterY;

        const right_hand_s_x = (right_hand.x - camera.x) * camera.zoom + screenCenterX;
        const right_hand_s_y = (right_hand.y - camera.y) * camera.zoom + screenCenterY;

        const waist_s_x = (waist.x - camera.x) * camera.zoom + screenCenterX;
        const waist_s_y = (waist.y - camera.y) * camera.zoom + screenCenterY;

        const left_knee_s_x = (left_knee.x - camera.x) * camera.zoom + screenCenterX;
        const left_knee_s_y = (left_knee.y - camera.y) * camera.zoom + screenCenterY;

        const left_foot_s_x = (left_foot.x - camera.x) * camera.zoom + screenCenterX;
        const left_foot_s_y = (left_foot.y - camera.y) * camera.zoom + screenCenterY;

        let left_shoe_x = left_knee.x - waist.x;
        let left_shoe_y = left_knee.y - waist.y;

        var left_shoe_length = Math.sqrt(Math.pow(left_shoe_x, 2) + Math.pow(left_shoe_y, 2));
        var left_shoe_x_normalized = left_shoe_x / left_shoe_length;
        var left_shoe_y_normalized = left_shoe_y / left_shoe_length;

        left_shoe_x = left_shoe_x_normalized * 4;
        left_shoe_y = left_shoe_y_normalized * 4;

        left_shoe_x += left_foot.x;
        left_shoe_y += left_foot.y;

        const left_shoe_s_x = (left_shoe_x - camera.x) * camera.zoom + screenCenterX;
        const left_shoe_s_y = (left_shoe_y - camera.y) * camera.zoom + screenCenterY;

        const right_knee_s_x = (right_knee.x - camera.x) * camera.zoom + screenCenterX;
        const right_knee_s_y = (right_knee.y - camera.y) * camera.zoom + screenCenterY;

        let right_shoe_x = right_knee.x - waist.x;
        let right_shoe_y = right_knee.y - waist.y;

        const right_shoe_length = Math.sqrt(Math.pow(right_shoe_x, 2) + Math.pow(right_shoe_y, 2));
        const right_shoe_x_normalized = right_shoe_x / right_shoe_length;
        const right_shoe_y_normalized = right_shoe_y / right_shoe_length;


        right_shoe_x = right_shoe_x_normalized * 4;
        right_shoe_y = right_shoe_y_normalized * 4;

        right_shoe_x += right_foot.x;
        right_shoe_y += right_foot.y;

        const right_shoe_s_x = (right_shoe_x - camera.x) * camera.zoom + screenCenterX;
        const right_shoe_s_y = (right_shoe_y - camera.y) * camera.zoom + screenCenterY;

        const right_foot_s_x = (right_foot.x - camera.x) * camera.zoom + screenCenterX;
        const right_foot_s_y = (right_foot.y - camera.y) * camera.zoom + screenCenterY;

        var canvas_ctx = this.canvasCtx
        canvas_ctx.strokeStyle = '#000000';
        canvas_ctx.lineWidth = 5 * zoom;
        canvas_ctx.lineCap = 'round';
        canvas_ctx.lineJoin = 'round';

        canvas_ctx.beginPath();
        canvas_ctx.moveTo(head_s_x, head_s_y);
        canvas_ctx.lineTo(left_elbow_s_x, left_elbow_s_y);
        canvas_ctx.lineTo(left_hand_s_x, left_hand_s_y);
        canvas_ctx.stroke();

        canvas_ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        canvas_ctx.beginPath();
        canvas_ctx.moveTo(head_s_x, head_s_y);
        canvas_ctx.lineTo(right_elbow_s_x, right_elbow_s_y);
        canvas_ctx.lineTo(right_hand_s_x, right_hand_s_y);
        canvas_ctx.stroke();

        canvas_ctx.strokeStyle = '#000000';
        canvas_ctx.lineWidth = 8 * zoom;
        canvas_ctx.beginPath();
        canvas_ctx.moveTo(head_s_x, head_s_y);
        canvas_ctx.lineTo(waist_s_x, waist_s_y);
        canvas_ctx.stroke();

        canvas_ctx.lineWidth = 5 * zoom;
        canvas_ctx.beginPath();
        canvas_ctx.moveTo(waist_s_x, waist_s_y);
        canvas_ctx.lineTo(left_knee_s_x, left_knee_s_y);
        canvas_ctx.lineTo(left_foot_s_x, left_foot_s_y);
        canvas_ctx.lineTo(left_shoe_s_x, left_shoe_s_y);
        canvas_ctx.stroke();

        canvas_ctx.strokeStyle = 'rgba(0,0,0,0.5)';
        canvas_ctx.lineWidth = 5 * zoom;
        canvas_ctx.beginPath();
        canvas_ctx.moveTo(waist_s_x, waist_s_y);
        canvas_ctx.lineTo(right_knee_s_x, right_knee_s_y);
        canvas_ctx.lineTo(right_foot_s_x, right_foot_s_y);
        canvas_ctx.lineTo(right_shoe_s_x, right_shoe_s_y);
        canvas_ctx.stroke();

        head_s_x = (head_s_x + ((head_s_x - waist_s_x) * 0.25));
        head_s_y = (head_s_y + ((head_s_y - waist_s_y) * 0.25));

        canvas_ctx.lineWidth = 1 * zoom;
        canvas_ctx.strokeStyle = '#000000';
        canvas_ctx.fillStyle = '#FFFFFF';

        var b_x = head_s_x - waist_s_x;
        var b_y = head_s_y - waist_s_y;

        var waist_pos, head_pos;

        if (dir < 0)
        {
            head_pos = head;
            waist_pos = waist;
        }
        else
        {
            waist_pos = head;
            head_pos = waist;
        }

        var waist_pos_x = waist_pos.x;
        var waist_pos_y = waist_pos.y;
        var head_pos_x = head_pos.x;
        var head_pos_y = head_pos.y;

        var diff_x = waist_pos_x - head_pos_x;
        var diff_y = waist_pos_y - head_pos_y;

        var draw_head_angle = -(Math.atan2(diff_x, diff_y) + (Math.PI));

        const player_head = player.head;
        const player_head_image = player.head.getCanvas(zoom);

        var player_head_width = player_head.width;
        var player_head_height = player_head.height;
        var player_head_scale = player_head.scale;
        var player_head_offset_x = player_head.offsetX;
        var player_head_offset_y = player_head.offsetY;

        player_head_width = player_head_width * zoom * player_head_scale;
        player_head_height = player_head_height * zoom * player_head_scale;

        player_head_offset_x = (player_head_offset_x * zoom) - (player_head_width / 2);
        player_head_offset_y = (player_head_offset_y * zoom) - (player_head_height / 2);

        canvas_ctx.translate(head_s_x, head_s_y);
        canvas_ctx.rotate(draw_head_angle);
        if (dir < 0)
        {
            canvas_ctx.scale(1, -1);
        }
        canvas_ctx.drawImage(player_head_image, player_head_offset_x, player_head_offset_y, player_head_width, player_head_height);
        if (dir < 0)
        {
            canvas_ctx.scale(1, -1);
        }
        canvas_ctx.rotate(-draw_head_angle);
        canvas_ctx.translate(-head_s_x, -head_s_y);
    }
}

export default RagdollRenderer;
